import * as Config from '../../../config';
import React, { useState, useCallback, useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

// import ButtonAudio from './ButtonAudio'; // DEPRECATED
// import ButtonAircore from '../aircore/ButtonAircore'; // DEPRECATED
import Message from './Message';
import InputMessageSocket from './InputMessageSocket';
import ChevronActive from '../svg/ChevronActive';
import ChevronInactive from '../svg/ChevronInactive';
import './Chat.css';

const COLORS = ['#00A6ED', '#EC7D10', '#EF476F', '#9654FA', '#00A6ED',/* '#5CA7FB', '#D2BF43', '#5C5CFB' */];

function ConnectedModalChat({ visible, messages = [], dimension, players, showAudio }) {
  const viewers = players.filter(x => !x.active).length;
  const actives = players.filter(x => x.active);
  const [isPaused, setPause] = useState(false);
  const [show, setShow] = useState(true);

  const isActive = (userID) => {
    const i = actives.findIndex( x => x.id === userID );
    return (i >= 0 && i < 4);
  }

  const getColor = (userID) => {
    const i = actives.findIndex( x => x.id === userID );
    return (i >= 0 && i < 4) ? COLORS[i] : Config.TYPE_LIGHT;
  }

  const getAvatar = (userID) => {
    const i = actives.findIndex( x => x.id === userID );
    return (i >= 0 && i < 4) ? actives[i].avatar : null;
  }

  const toggleSection = () => setShow(!show);

  const onScroll = useCallback((e) => {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if ((scrollTop + offsetHeight) >= scrollHeight - 1) {
      setPause(false);
    } else {
      setPause(true);
    }
  }, [])
  const clearPause = () => { setPause(false); }

  useEffect(() => {
    const el = document.getElementById(`chat-messages`);
    if (el && visible && !isPaused && show) { el.scrollTop = el.scrollHeight }
  }, [messages, visible, isPaused, show])

  const calcHeight = (showAudio) ? 180 : 135;

  // Limited display messages (50) to reduce re-rendering (Reducer)
  return visible ? (
    <div className={`chat-modal flexColumn`} style={{gap: 10}}>
      <div className={'flexRow'} style={{ gap: 9, alignItems: 'center' }}>
        <div onClick={toggleSection}>
          {show ? <ChevronInactive /> : <ChevronActive /> }
        </div>
        <span className={`type-medium fz15 type-light`}>Chat</span>
        {viewers > 0 && (<span className={`type-medium fz13 type-light`} style={{position: `absolute`, right: 16}}>{viewers} Viewer(s)</span>)}
      </div>
      <div id={`chat-messages`} onScroll={onScroll} className={`chat-messages ${!show && 'hide'}`} style={{height: `calc(100% - ${calcHeight}px)`}}>
        { messages.map( (message, mID) => (
          <Message key={mID}
            color={(message.type === `normal`) ? '#FFFFFF' : '#8E8E93' }
            userID={message.userID}
            username={message.fromUser}
            usercolor={getColor(message.userID)}
            separator={(message.type === `normal`) ? `: ` : ` ` }
            content={message.content}
            type={message.type}
            active={isActive(message.userID)}
            avatar={getAvatar(message.userID)}
          />
        )) }
      </div>
      <InputMessageSocket className={!show ? 'hide' : ''} withPause={isPaused} onPauseClick={clearPause} />
      <div className={`flexRow aircore-section ${!show && 'hide'}`} style={{alignItems: 'center', height: 40}}>
        { /* <ButtonAudio /> */ }
        { /* <ButtonAircore /> */ }
      </div>
    </div>
  ) : null
}

ConnectedModalChat.propTypes = {
  visible: PropTypes.bool,
  messages: PropTypes.array.isRequired
}

const ModalChat = connect(
  state => ({
    dimension: state.dimension,
    visible: !!(state.serverPM && state.inRoomPM && state.showChatPM && (state.user || state.isOutsider)),
    messages: state.messagesPM || [],
    players: (state.playersInRoomPM) ? state.playersInRoomPM : [],
    showAudio: state.showAudio
  })
)(ConnectedModalChat);

export default ModalChat;
